import React from 'react';
import styled from 'styled-components';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import { useAuth } from '../context/AuthContext';
import LoadingScreen from './LoadingScreen';
import EmailVerificationWarning from './EmailVerificationWarning';

// مكونات التنسيق
const LayoutContainer = styled.div`
  display: flex;
  min-height: 100vh;
  background-color: var(--background-color);
`;

const MainContent = styled.main`
  flex: 1;
  margin-right: 280px;
  padding: 2rem;
  transition: all 0.3s ease;
  
  @media (max-width: 768px) {
    margin-right: 0;
    padding: 1rem;
  }
`;

const PageHeader = styled.div`
  margin-bottom: 2rem;
`;

const PageTitle = styled.h1`
  font-size: 1.75rem;
  color: var(--gray-800);
  margin-bottom: 0.5rem;
`;

const PageDescription = styled.p`
  color: var(--gray-600);
  font-size: 1rem;
  max-width: 600px;
`;

// مكون تخطيط لوحة التحكم
const DashboardLayout = ({ title, description }) => {
  const { loading, user } = useAuth();
  
  // عرض شاشة التحميل أثناء التحقق من الجلسة
  if (loading) {
    return <LoadingScreen />;
  }
  
  // التحقق من وجود مستخدم مسجل للدخول
  if (!user) {
    return null; // سيقوم AuthenticatedRoute بتحويل المستخدم للصفحة الرئيسية
  }
  
  return (
    <LayoutContainer>
      <Sidebar />
      <MainContent>
        {title && (
          <PageHeader>
            <PageTitle>{title}</PageTitle>
            {description && <PageDescription>{description}</PageDescription>}
          </PageHeader>
        )}
        <Outlet />
        <EmailVerificationWarning />
      </MainContent>
    </LayoutContainer>
  );
};

export default DashboardLayout;